import {InteractiveChatItem} from './interactive-chat.type';

export enum TextChatContentType {
    File = 'file',
    Text = 'text',
    InteractiveChat = 'interactive-chat',
    Chatbot = 'chatbot',
    InteractiveChatAnswer = 'interactive-chat-answer',
    ChatbotConfirmation = 'chatbot-confirmation',
    IdleReminder = 'idle-reminder',
    InteractiveChatError = 'interactive-chat-error'
}

export enum DefaultParticipant {
    System = 'system',
    Chatbot = 'chatbot'
}

export type InteractiveChatMessageData = {
    chatOptionIndex?: number;
    nodeValue?: InteractiveChatItem;
    options?: {
        content: string;
        contentType: TextChatContentType;
        nodeValue?: InteractiveChatItem;
    }[];
}

export type TextChatMessage = {
    id: string;
    date: string;
    index: number;
    content: string;
    contentType: TextChatContentType,
    data?: InteractiveChatMessageData,
    base64?: string;
    meta?: {
        isTranscription?: boolean;
        isIntermediateMessage?: boolean;
    }
    from?: {
        id: string;
        name: string;
    }
}

export type SessionActivityTextChatInteractiveChatState = {
    inProgress: boolean;
    chatbotActive?: boolean;
    rootNodeId?: string;
    path?: number[];
}

export type TextChatThreads = {[threadId: string]: TextChatMessage[]};
